/**
 * 权限
 */

import { FullChildContainer } from '@acgn/herm/src/components';

const roleRoutes: any = {
  path: 'comic-role',
  name: '权限设置',
  icon: 'ift-limit',
  meta: {
    breadcrumbHidden: true
  },
  component: FullChildContainer,
  children: [
    {
      path: '',
      redirect: 'list'
    },
    {
      path: 'list',
      redirect: 'list',
      name: '权限设置',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-roleList',
          meta: {
            text: '角色列表',
            type: 'list',
            role: ['4002']
          },
          component: () => import('../views/role/list.vue')
        },
        {
          path: 'edit/:id',
          name: 'desk-roleEdit',
          meta: {
            text: '编辑权限',
            type: 'edit',
            role: ['4003']
          },
          component: () => import('../views/role/edit.vue')
        }
      ]
    }
  ]
};

export {
  roleRoutes
};
